import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import ROUTES from '../../routes';
import {
  capitalizeFirstLetter,
  capitalizeSQL,
  extraFormat,
} from '../../utils/formatting';

const Breadcrumbs = ({ isLearn, postTitle }) => {
  const router = useRouter();
  const { id, slug } = router.query;
  const [section, setSection] = useState();
  const [post, setPost] = useState();
  const [databaseId, setDatabaseId] = useState();

  useEffect(() => {
    if (router?.asPath) {
      const paths = router.asPath.split('/').filter((p) => !!p); // Remove empty strings

      if (paths[0]) {
        setSection({
          text: capitalizeFirstLetter(capitalizeSQL(paths[0])),
          href: `/${paths.slice(0, 1).join('/')}`,
        });
      }

      if (!slug) {
        if (isLearn) {
          setDatabaseId({
            text: extraFormat(postTitle),
            href: `/${paths.slice(0, 2).join('/')}`,
          });
        } else {
          setPost({ text: postTitle, href: `/${paths.slice(0, 2).join('/')}` });
        }
      }

      if (paths[2]) {
        setPost({ text: postTitle, href: `/${paths.slice(0, 3).join('/')}` });
      }

      if (isLearn) {
        setDatabaseId({
          text: capitalizeFirstLetter(capitalizeSQL(extraFormat(id))),
          href: ROUTES.learnPost(id).asPath,
        });
      }
    }
  }, [router]);

  return (
    <nav className="w-full mb-4" style={{ marginTop: '7px' }}>
      <ol className="list-reset flex text-black" style={{ minHeight: '24px' }}>
        {section && (
          <div className="flex items center">
            <li>
              <Link href={section.href}>
                <a className="text-gray-500 hover:text-blue-200 text-sm font-inter leading-normal">
                  {section.text}
                </a>
              </Link>
            </li>
            <span className="mx-2 text-gray-300 leading-normal">/</span>
          </div>
        )}
        {databaseId && (
          <div className="flex items center">
            <li>
              <Link href={ROUTES.learnPost('id').href} as={databaseId.href}>
                <a className="text-gray-500 hover:text-blue-200 text-sm font-inter leading-normal">
                  {databaseId.text}
                </a>
              </Link>
            </li>
            {post && (
              <span className="mx-2 text-gray-300 leading-normal">/</span>
            )}
          </div>
        )}
        {post && (
          <li>
            <Link
              href={`/${isLearn ? 'learn-sql' : 'docs'}/[id]/[slug]`}
              as={post.href}
            >
              <a className="text-gray-500 text-sm font-inter leading-normal">
                {post.text}
              </a>
            </Link>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
